import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from 'uikit/inputs';

const FormFieldBoolean = ({ fieldId, fieldKey, schema = {}, updateField, value = false }) => {
  let inputFieldId = fieldId;

  if (schema.labelText) {
    inputFieldId = `${fieldId}-input`;
  }

  return (
    <Checkbox
      id={inputFieldId}
      name={fieldKey}
      value={value}
      label={schema.labelText}
      isDisabled={schema.isDisabled}
      isIndeterminate={schema.isIndeterminate}
      checkedIcon={schema.checkedIcon}
      uncheckedIcon={schema.uncheckedIcon}
      indeterminateIcon={schema.indeterminateIcon}
      onChange={updateField}
    />
  );
};

FormFieldBoolean.propTypes = {
  fieldId: PropTypes.string.isRequired,
  fieldKey: PropTypes.string.isRequired,
  value: PropTypes.bool,
  updateField: PropTypes.func.isRequired,
  schema: PropTypes.shape({
    labelText: PropTypes.string,
    isDisabled: PropTypes.bool,
  }),
};

export default FormFieldBoolean;
